<button
  mat-menu-item
  class="header-menu-item"
  data-testid="header-faqs"
  (click)="openWidget()"
>
  <span>
    <mat-icon style="margin-right: 16px; font-size: 24px; width: 24px; height: 24px;" aria-hidden="true">help_outline</mat-icon>
    FAQs
  </span>
</button>
